import { render, staticRenderFns } from "./act-request.vue?vue&type=template&id=dc67a9fe&"
import script from "./act-request.vue?vue&type=script&lang=js&"
export * from "./act-request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/act-request.vue
// module id = 1412
// module chunks = 0